<template>
<div class="chapter">
<div class="inner_page">
<h1 class="fm-title" id="fm-1"><a id="page_ix">A<span class="smallcaps">BBREVIATIONS</span> <span class="smallcaps">AND</span> S<span class="smallcaps">YMBOLS</span></a></h1><a id="page_ix">
<h1 class="sec1">I. Miscellaneous Abbreviations and Symbols</h1>
<table>
<tbody>
<tr>
<td class="w25">
<p class="t-left">DH</p></td>
<td class="w70">
<p class="t-left">Deuteronomistic History</p></td>
</tr>
<tr>
<td class="w25">
<p class="t-left">dtr</p></td>
<td class="w70">
<p class="t-left">deuteronomistic; when needed, “deuteronomic” will be written in full</p></td>
</tr>
<tr>
<td class="w25">
<p class="t-left">Dtr.</p></td>
<td class="w70">
<p class="t-left">M. Noth’s abbreviation for his Deuteronomist</p></td>
</tr>
<tr>
<td class="w25">
<p class="t-left">DtrN</p></td>
<td class="w70">
<p class="t-left">the “nomistic” (= legally oriented) dtr editor/editing (used when discussing the hypothesis of an exilic DH with two revisions later in the exile, postulated by Smend, Dietrich, Veijola, and others)</p></td>
</tr>
<tr>
<td class="w25">
<p class="t-left">DtrP</p></td>
<td class="w70">
<p class="t-left">the later dtr editor/editing identifiable by interest in matters prophetic (used when discussing the hypothesis of an exilic DH with two revisions later in the exile, postulated by Smend, Dietrich, Veijola, and others)</p></td>
</tr>
<tr>
<td class="w25">
<p class="t-left">LXX</p></td>
<td class="w70">
<p class="t-left">Septuagint (= Greek)</p></td>
</tr>
<tr>
<td class="w25">
<p class="t-left">LXX<sup>A</sup></p></td>
<td class="w70">
<p class="t-left">Septuagint: Codex Alexandrinus</p></td>
</tr>
<tr>
<td class="w25">
<p class="t-left">LXX<sup>B</sup></p></td>
<td class="w70">
<p class="t-left">Septuagint: Codex Vaticanus</p></td>
</tr>
<tr>
<td class="w25">
<p class="t-left">LXX<sup>L</sup></p></td>
<td class="w70">
<p class="t-left">Septuagint: Lucianic recension (often equivalent to the mss. group boc<sup>2</sup>e<sup>2</sup>)</p></td>
</tr>
<tr>
<td class="w25">
<p class="t-left">MT</p></td>
<td class="w70">
<p class="t-left">Masoretic Text (= Hebrew)</p></td>
</tr>
<tr>
<td class="w25">
<p class="t-left">PR</p></td>
<td class="w70">
<p class="t-left">Prophetic Record</p></td>
</tr>
<tr>
<td class="w25">
<p class="t-left">4QSam</p></td>
<td class="w70">
<p class="t-left">Samuel material from Cave 4 at Qumran</p></td>
</tr>
</tbody>
</table>
<p class="hpara">N.B.: The asterisk (*) is used throughout this volume to indicate that only the relevant parts of the verse or verses so marked are referred to. In other words, the asterisk (*) is a signal that a part or parts of the text involved are excluded from the reference.</p>
<table>
<tbody>
<tr>
<td class="w25">
<p class="t-left">→</p></td>
<td class="w70">
<p class="t-left">indicates terms in the Glossary.</p></td>
</tr>
</tbody>
</table>
</a><h1 class="sec1"><a id="page_ix"></a><a id="page_x">II. Publications</a></h1><a id="page_x">
<table>
<tbody>
<tr>
<td class="w25">
<p class="t-left">AASF</p></td>
<td class="w70">
<p class="t-left">Annales Academiae Scientiarum Fennicae</p></td>
</tr>
<tr>
<td class="w25">
<p class="t-left">AB</p></td>
<td class="w70">
<p class="t-left">Anchor Bible</p></td>
</tr>
<tr>
<td class="w25">
<p class="t-left"><em>ABD</em></p></td>
<td class="w70">
<p class="t-left"><em>Anchor Bible Dictionary</em></p></td>
</tr>
<tr>
<td class="w25">
<p class="t-left"><em>ABR</em></p></td>
<td class="w70">
<p class="t-left"><em>Australian Biblical Review</em></p></td>
</tr>
<tr>
<td class="w25">
<p class="t-left">AnBib</p></td>
<td class="w70">
<p class="t-left">Analecta biblica</p></td>
</tr>
<tr>
<td class="w25">
<p class="t-left"><em>ANET</em></p></td>
<td class="w70">
<p class="t-left"><em>Ancient Near Eastern Texts Relating to the Old Testament</em></p></td>
</tr>
<tr>
<td class="w25">
<p class="t-left"><em>APSP</em></p></td>
<td class="w70">
<p class="t-left"><em>American Philosophical Society Proceedings</em></p></td>
</tr>
<tr>
<td class="w25">
<p class="t-left">ATANT</p></td>
<td class="w70">
<p class="t-left">Abhandlungen zur Theologie des Alten und Neuen Testaments</p></td>
</tr>
<tr>
<td class="w25">
<p class="t-left"><em>BASOR</em></p></td>
<td class="w70">
<p class="t-left"><em>Bulletin of the American Schools of Oriental Research</em></p></td>
</tr>
<tr>
<td class="w25">
<p class="t-left">BBB</p></td>
<td class="w70">
<p class="t-left">Bonner biblische Beiträge</p></td>
</tr>
<tr>
<td class="w25">
<p class="t-left">BET</p></td>
<td class="w70">
<p class="t-left">Beiträge zur evangelischen Theologie</p></td>
</tr>
<tr>
<td class="w25">
<p class="t-left"><em>Bib</em></p></td>
<td class="w70">
<p class="t-left"><em>Biblica</em></p></td>
</tr>
<tr>
<td class="w25">
<p class="t-left"><em>BJRL</em></p></td>
<td class="w70">
<p class="t-left"><em>Bulletin of the John Rylands University Library</em></p></td>
</tr>
<tr>
<td class="w25">
<p class="t-left">BWANT</p></td>
<td class="w70">
<p class="t-left">Beiträge zur Wissenschaft vom Alten und Neuen Testament</p></td>
</tr>
<tr>
<td class="w25">
<p class="t-left">BZAW</p></td>
<td class="w70">
<p class="t-left">Beihefte zur <em>ZAW</em></p></td>
</tr>
<tr>
<td class="w25">
<p class="t-left">CBC</p></td>
<td class="w70">
<p class="t-left">Cambridge Bible Commentary</p></td>
</tr>
<tr>
<td class="w25">
<p class="t-left"><em>CBQ</em></p></td>
<td class="w70">
<p class="t-left"><em>Catholic Biblical Quarterly</em></p></td>
</tr>
<tr>
<td class="w25">
<p class="t-left">CBQMS</p></td>
<td class="w70">
<p class="t-left">Catholic Biblical Quarterly Monograph Series</p></td>
</tr>
<tr>
<td class="w25">
<p class="t-left"><em>DH</em></p></td>
<td class="w70">
<p class="t-left">Martin Noth, <em>The Deuteronomistic History.</em> 2nd ed. Sheffield: Sheffield Academic, 1991</p></td>
</tr>
<tr>
<td class="w25">
<p class="t-left"><em>ETL</em></p></td>
<td class="w70">
<p class="t-left"><em>Ephemerides theologicae lovanienses</em></p></td>
</tr>
<tr>
<td class="w25">
<p class="t-left"><em>FAT</em></p></td>
<td class="w70">
<p class="t-left"><em>Forschungen zum Alten Testament</em></p></td>
</tr>
<tr>
<td class="w25">
<p class="t-left">FB</p></td>
<td class="w70">
<p class="t-left">Forschung zur Bibel</p></td>
</tr>
<tr>
<td class="w25">
<p class="t-left">FOTL</p></td>
<td class="w70">
<p class="t-left">Forms of the Old Testament Literature</p></td>
</tr>
<tr>
<td class="w25">
<p class="t-left">FRLANT</p></td>
<td class="w70">
<p class="t-left">Forschungen zur Religion und Literatur des Alten und Neuen Testaments</p></td>
</tr>
<tr>
<td class="w25">
<p class="t-left">HAT</p></td>
<td class="w70">
<p class="t-left">Handbuch zum Alten Testament</p></td>
</tr>
<tr>
<td class="w25">
<p class="t-left">HSM</p></td>
<td class="w70">
<p class="t-left">Harvard Semitic Monographs</p></td>
</tr>
<tr>
<td class="w25">
<p class="t-left"><em>HUCA</em></p></td>
<td class="w70">
<p class="t-left">Hebrew Union College Annual</p></td>
</tr>
<tr>
<td class="w25">
<p class="t-left">ICC</p></td>
<td class="w70">
<p class="t-left">International Critical Commentary</p></td>
</tr>
<tr>
<td class="w25">
<p class="t-left"><em>JBL</em></p></td>
<td class="w70">
<p class="t-left"><em>Journal of Biblical Literature</em></p></td>
</tr>
<tr>
<td class="w25">
<p class="t-left"><em>JNSL</em></p></td>
<td class="w70">
<p class="t-left"><em>Journal of Northwest Semitic Languages</em></p></td>
</tr>
<tr>
<td class="w25">
<p class="t-left">JPS</p></td>
<td class="w70">
<p class="t-left">Jewish Publication Society, The Holy Scriptures (1917)</p></td>
</tr>
<tr>
<td class="w25">
<p class="t-left"><em>JQR</em></p></td>
<td class="w70">
<p class="t-left"><em>Jewish Quarterly Review</em></p></td>
</tr>
<tr>
<td class="w25">
<p class="t-left"><em>JSOT</em></p></td>
<td class="w70">
<p class="t-left"><em>Journal for the Study of the Old Testament</em></p></td>
</tr>
<tr>
<td class="w25">
<p class="t-left">JSOTSup</p></td>
<td class="w70">
<p class="t-left">Journal for the Study of the Old Testament Supplement</p></td>
</tr>
<tr>
<td class="w25">
<p class="t-left"><em>JTS</em></p></td>
<td class="w70">
<p class="t-left"><em>Journal of Theological Studies</em></p></td>
</tr>
<tr>
<td class="w25">
<p class="t-left">KHC</p></td>
<td class="w70">
<p class="t-left">Kurzer Hand-Commentar zum Alten Testament</p></td>
</tr>
<tr>
<td class="w25">
<p class="t-left">NAB</p></td>
<td class="w70">
<p class="t-left">New American Bible</p></td>
</tr>
<tr>
<td class="w25">
<p class="t-left">NRSV</p></td>
<td class="w70">
<p class="t-left">New Revised Standard Version</p></td>
</tr>
<tr>
<td class="w25">
<p class="t-left">OBO</p></td>
<td class="w70">
<p class="t-left">Orbis biblicus et orientalis</p></td>
</tr>
<tr>
<td class="w25">
<p class="t-left">OTL</p></td>
<td class="w70">
<p class="t-left">Old Testament Library</p></td>
</tr>
<tr>
<td class="w25">
<p class="t-left"><em>RB</em></p></td>
<td class="w70">
<p class="t-left"><em>Revue biblique</em></p></td>
</tr>
<tr>
<td class="w25">
<p class="t-left">RSV</p></td>
<td class="w70">
<p class="t-left">Revised Standard Version</p></td>
</tr>
<tr>
<td class="w25">
<p class="t-left">SBLDS</p></td>
<td class="w70">
<p class="t-left">Society of Biblical Literature Dissertation Series</p></td>
</tr>
<tr>
<td class="w25">
<p class="t-left"><a id="page_xi">SBLMS</a></p></td>
<td class="w70">
<p class="t-left">Society of Biblical Literature Monograph Series</p></td>
</tr>
<tr>
<td class="w25">
<p class="t-left">SBLSCS</p></td>
<td class="w70">
<p class="t-left">Society of Biblical Literature Septuagint and Cognate Studies</p></td>
</tr>
<tr>
<td class="w25">
<p class="t-left">SBS</p></td>
<td class="w70">
<p class="t-left">Stuttgarter Bibelstudien</p></td>
</tr>
<tr>
<td class="w25">
<p class="t-left">TB</p></td>
<td class="w70">
<p class="t-left">Theologische Bücherei</p></td>
</tr>
<tr>
<td class="w25">
<p class="t-left">ThZ</p></td>
<td class="w70">
<p class="t-left">Theologische Zeitschrift</p></td>
</tr>
<tr>
<td class="w25">
<p class="t-left"><em>VT</em></p></td>
<td class="w70">
<p class="t-left"><em>Vetus Testamentum</em></p></td>
</tr>
<tr>
<td class="w25">
<p class="t-left">WBC</p></td>
<td class="w70">
<p class="t-left">Word Biblical Commentary</p></td>
</tr>
<tr>
<td class="w25">
<p class="t-left">WMANT</p></td>
<td class="w70">
<p class="t-left">Wissenschaftliche Monographien zum Alten und Neuen Testament</p></td>
</tr>
<tr>
<td class="w25">
<p class="t-left"><em>ZAW</em></p></td>
<td class="w70">
<p class="t-left"><em>Zeitschrift für die alttestamentliche Wissenschaft</em></p></td>
</tr>
<tr>
<td class="w25">
<p class="t-left"><em>ZThK</em></p></td>
<td class="w70">
<p class="t-left"><em>Zeitschrift für Theologie und Kirche</em></p></td>
</tr>
</tbody>
</table>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 006_Abbre.vue?53146801